import styled from 'styled-components'
import { colors } from '~/styles/colors'
import { fonts } from '~/styles/fonts'
import { media } from '~/styles/media'

export const Page = styled.div({
  display: 'flex',
  minHeight: '100vh',
  justifyContent: 'stretch',
})

export const Header = styled.header({
  width: '100%',
  padding: '30px 32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  top: 0,
  left: 0,
  position: 'fixed',

  [media.maxSmall]: {
    padding: '32px 20px',
  },
})

export const Side = styled.aside({
  flex: 1,
  maxWidth: 480,
  background:
    'url(/img/background.png) 100% 100% no-repeat, linear-gradient(163.46deg, #6805E5 -10.04%, #8733FE 115.8%)',
  backgroundSize: 'contain',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 72px',
  display: 'none',

  [media.large]: {
    display: 'flex',
  },
})

export const Main = styled.main({
  flex: 2,
  display: 'flex',
  [media.maxSmall]: {
    padding: '0 20px',
  },
  justifyContent: 'center',
  alignItems: 'center',
})

export const Subheading = styled.h2({
  fontSize: '1rem',
  lineHeight: 2,
  fontWeight: fonts.text.regular,
  textAlign: 'center',
  color: colors.slateGray,
  marginBottom: 40,

  a: {
    color: colors.dark,
    fontWeight: fonts.text.medium,
  },

  strong: {
    color: colors.dark,
    fontWeight: fonts.text.medium,
  },
})

export const Divider = styled.div({
  fontSize: '0.875rem',
  lineHeight: 1.5,
  color: colors.dark,
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  margin: '24px 0 16px',

  '&:before, &:after': {
    content: '""',
    flex: 1,
    borderBottom: colors.border,
  },

  '&:before': {
    marginRight: 15,
  },

  '&:after': {
    marginLeft: 15,
  },
})
